import { render } from "./LottoBallNumber.vue?vue&type=template&id=0abb5e0a&scoped=true"
import script from "./LottoBallNumber.vue?vue&type=script&lang=js"
export * from "./LottoBallNumber.vue?vue&type=script&lang=js"

import "./LottoBallNumber.vue?vue&type=style&index=0&id=0abb5e0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abb5e0a"]])

export default __exports__